module.exports = __webpack_public_path__ + "static/media/2dde1b2a-97d2-4a71-a8a2-6930c7ab522e.2075324f.png";